<template>
  <div style="height: 100%">
    <div style="height: 50px;">
      <div v-if="circle_type === 1">
        <el-button size="small" type="primary" :disabled="!isCircle" @click="resetCircle()">重新选择</el-button>
        <el-button v-if="circlePoint.point.length !== 0 && circlePoint.radius !== ''" size="small" type="primary" @click="getCircleMap()" :disabled="isCircle">构建圆形</el-button>
        <el-button v-else size="small" type="primary" :disabled="true">构建圆形</el-button>
        <el-button size="small" type="primary" :disabled="!isCircle" @click="startEditCircle()">开始编辑</el-button>
        <el-button size="small" type="primary" :disabled="!isCircle" @click="endEditCircle()">结束编辑</el-button>
      </div>
      <div v-else-if="circle_type === 2">
        <el-button size="small" type="primary" :disabled="!isPolygon" @click="resetPolygon()">重新选择</el-button>
        <el-button v-if="polygonPoint.length !== 0 && polygonPoint.length !== 1" size="small" type="primary" @click="getPolygonMap()" :disabled="isPolygon">构建多边形</el-button>
        <el-button v-else size="small" type="primary" :disabled="true">构建多边形</el-button>
        <el-button size="small" type="primary" :disabled="!isPolygon" @click="startEditPolygon()">开始编辑</el-button>
        <el-button size="small" type="primary" :disabled="!isPolygon" @click="endEditPolygon()">结束编辑</el-button>
      </div>
      <div v-else style="font-size: 14px;color: #f67373;line-height: 50px">请先选择围栏类型进行绘制。</div>
    </div>
    <div class="search-inpt">
      <div style="margin-top: 15px;margin-left: 30px;">
        <el-autocomplete v-if="circle_type === 1" size="small" style="width: 300px" v-model="keyword" :disabled="isCircle"
                         :fetch-suggestions="searchChange" placeholder="输入关键字选取地点" :trigger-on-focus="false" @select="searchSelect"
        ></el-autocomplete>
        <el-autocomplete v-if="circle_type === 2" size="small" style="width: 300px" v-model="keyword" :disabled="isPolygon"
                         :fetch-suggestions="searchChange" placeholder="输入关键字选取地点" :trigger-on-focus="false" @select="searchSelect"
        ></el-autocomplete>
        <el-input v-if="circle_type === 1" size="small" style="width: 110px" type="number" placeholder="输入半径(单位:米)" v-model="circlePoint.radius" :disabled="isCircle"></el-input>
      </div>
    </div>
    <div style="height: calc(100% - 50px);width: 100%;">
      <iframe id="mainIframe" ref="mainIframe" name="mainIframe"
              style="width: 100%;height: 100%;margin: auto" src="./static/Amap.html" frameborder="0" scrolling="no">
      </iframe>
    </div>
  </div>
</template>

<script>

export default {
  name: 'addEditElectronicMap',
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      mapType: -1,
      isAdd: false,
      keyword: '',
      circle_type: '',
      // 圆形
      circlePoint: {
        point: [],
        radius: ''
      },
      isCircle: false,
      // 多边形
      polygonPoint: [], // [[116.475334, 39.997534], [116.476627, 39.998315], [116.478603, 39.99879], [116.478529, 40.000296], [116.475082, 40.000151], [116.473421, 39.998717]],
      isPolygon: false
    }
  },
  created () {
    console.log('created')
    this.golobleObject.initMapCompleted = this.initMapCompleted
    this.golobleObject.mapClickEvent = this.mapClickEvent
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    initMapCompleted () {
      console.log(999, 'initMapCompleted')
      window.frames['mainIframe'].window.setMapClick(2)
      if (this.circle_type === 1) {
        this.getCircleMap()
      } else if (this.circle_type === 2) {
        this.getPolygonMap()
      }
    },
    mapClickEvent (obj) {
      if (obj.type === 'mapClick') {
        this.setMarker(obj.lng, obj.lat)
      }
    },
    searchSelect (e) {
      window.frames['mainIframe'].window.showDefaultAndCenter(e.poi)
    },
    searchChange (v, v1) {
      window.frames['mainIframe'].window.serchChange(this.keyword, v, v1)
    },
    // 编辑画图
    getEditDataMap (obj) {
      // console.log(123)
      this.circle_type = obj.circle_type
      if (obj.circle_type === 1) {
        let area = JSON.parse(obj.circle_area)
        this.circlePoint = {
          point: [area.point.y, area.point.x],
          radius: parseInt(area.radius)
        }
        this.getCircleMap()
      } else if (obj.circle_type === 2) {
        this.polygonPoint = []
        let area = JSON.parse(obj.circle_area)
        let path = []
        if (area['point1']) {
          path.push([area['point1'].y, area['point1'].x])
        }
        if (area['point2']) {
          path.push([area['point2'].y, area['point2'].x])
        }
        if (area['point3']) {
          path.push([area['point3'].y, area['point3'].x])
        }
        if (area['point4']) {
          path.push([area['point4'].y, area['point4'].x])
        }
        if (area['point5']) {
          path.push([area['point5'].y, area['point5'].x])
        }
        if (area['point6']) {
          path.push([area['point6'].y, area['point6'].x])
        }
        if (area['point7']) {
          path.push([area['point7'].y, area['point7'].x])
        }
        if (area['point8']) {
          path.push([area['point8'].y, area['point8'].x])
        }
        this.polygonPoint = path
        this.getPolygonMap()
      }
    },
    getChangeType (type) {
      window.frames['mainIframe'].window.removeMarkers()
      if (this.circle_type === 1) {
        this.resetCircle()
      } else if (this.circle_type === 2) {
        this.resetPolygon()
      }
      this.circle_type = parseInt(type)
    },
    addOrRemove () {
      this.isAdd = !this.isAdd
      if (!this.isAdd) {
        window.frames['mainIframe'].window.removeLayer()
      } else {
        window.frames['mainIframe'].window.addLayer()
      }
    },
    // 添加点
    setMarker (lng, lat) {
      if (this.circle_type === 1) {
        if (!this.isCircle) {
          window.frames['mainIframe'].window.removeMarkers()
          window.frames['mainIframe'].window.showDefault(lng, lat)
          this.circlePoint.point = [lng, lat]
        }
      } else if (this.circle_type === 2) {
        // console.log(this.markers.length)
        if (!this.isPolygon) {
          if (this.polygonPoint.length >= 8) {
            this.$message.error('最多构建8个点。')
          } else {
            window.frames['mainIframe'].window.showDefault(lng, lat)
            this.polygonPoint.push([lng, lat])
          }
        }
      }
    },
    // 圆形
    getCircleMap () {
      window.frames['mainIframe'].window.showCircle(this.circlePoint.point[0], this.circlePoint.point[1], this.circlePoint.radius)
      window.frames['mainIframe'].window.removeMarkers()
      this.isCircle = true
      let obj = {
        type: 1,
        circleObj: this.circlePoint
      }
      this.$emit('getMapArea', obj)
    },
    resetCircle () {
      window.frames['mainIframe'].window.removeCircle()
      window.frames['mainIframe'].window.removeMarkers()
      this.isCircle = false
      this.circlePoint = {
        point: [],
        radius: ''
      }
    },
    startEditCircle () {
      window.frames['mainIframe'].window.startEditCircle()
    },
    endEditCircle () {
      window.frames['mainIframe'].window.endEditCircle()
      // console.log(this.circle)
      this.circlePoint.point = window.frames['mainIframe'].window.getCircleCenter()
      this.circlePoint.radius = window.frames['mainIframe'].window.getCircleRadius()
      let obj = {
        type: 1,
        circleObj: this.circlePoint
      }
      this.$emit('getMapArea', obj)
    },
    // 多边形
    getPolygonMap () {
      let path = this.polygonPoint
      window.frames['mainIframe'].window.showPolygon(path)
      window.frames['mainIframe'].window.removeMarkers()
      this.isPolygon = true
      let obj = {
        type: 2,
        polygonArr: this.polygonPoint
      }
      this.$emit('getMapArea', obj)
    },
    resetPolygon () {
      window.frames['mainIframe'].window.removePolygon()
      window.frames['mainIframe'].window.removeMarkers()
      this.isPolygon = false
      this.polygonPoint = []
    },
    startEditPolygon () {
      window.frames['mainIframe'].window.startEditPolygon()
    },
    endEditPolygon () {
      window.frames['mainIframe'].window.endEditPolygon()
      let arr = window.frames['mainIframe'].window.getPolygonPath()
      this.polygonPoint = []
      for (let i = 0; i < arr.length; i++) {
        this.polygonPoint.push([arr[i].lng, arr[i].lat])
      }
      // console.log(999, this.polygonPoint)
      let obj = {
        type: 2,
        polygonArr: this.polygonPoint
      }
      this.$emit('getMapArea', obj)
    }
  }
}
</script>

<style scoped>
.icon-map{
  position: relative;
  top: 20px;
  left: 20px;
  width: 40px;
  height: 80px;
  background-color: #FFFFFF;
  box-shadow: 0 0 10px 0 #999999;
  border-radius: 4px;
  z-index: 999;
  cursor: pointer;
  text-align: center;
}
.search-inpt{
  z-index: 999;
  /*background-color: #7c98d9;*/
  height: 60px;
  width: 450px;
  position: absolute;
}
.inpt-box{
  margin-left: 30px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/addEditElectronicMap.vue